import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["active"]

  connect() {
    if (this.hasActiveTarget) {
      this.activeTarget.scrollIntoView({ inline: "center", block: "nearest" })
    }
  }
}
